import { defineMarker } from '@stylexjs/stylex';
export const fieldMarker = {
  xq57j7h: "xq57j7h",
  $$css: true
};
export const checkableMarker = {
  xx1hdd4: "xx1hdd4",
  $$css: true
};
export const labelMarker = {
  xnvr81h: "xnvr81h",
  $$css: true
};
export const inputIconMarker = {
  x9dj4wi: "x9dj4wi",
  $$css: true
};
export const inputGroupMarker = {
  x54qfst: "x54qfst",
  $$css: true
};
export const inputMarker = {
  xzn4wr5: "xzn4wr5",
  $$css: true
};
export const inputGroupAddonMarker = {
  x1j8yfs6: "x1j8yfs6",
  $$css: true
};